<template>
	<div class="basic-container popup">
		<div class="popup-visit-company-area">
			<form name="reportSendForm" id="reportSendForm" method="post" enctype="multipart/form-data">
				<h4>문서종류</h4>
				<section v-if="modalParam.popupType !== 'detail'">
					<div class="radio-wrapper">
						<input type="radio" :name="reportTypeNm" id="radio_i_report" value="I" v-model="reportDetail.reportType" />
						<label for="radio_i_report">보고서</label>
						<input type="radio" :name="reportTypeNm" id="radio_m_report" value="M" v-model="reportDetail.reportType" />
						<label for="radio_m_report">수정보고서</label>
						<input type="radio" :name="reportTypeNm" id="radio_f_report" value="F" v-model="reportDetail.reportType" />
						<label for="radio_f_report">정산증빙자료</label>
					</div>
				</section>
				<section v-if="modalParam.popupType === 'detail'">
					<span v-if="reportDetail.reportType === 'I'">보고서</span>
					<span v-else-if="reportDetail.reportType === 'M'">수정보고서</span>
					<span v-else-if="reportDetail.reportType === 'F'">정산증빙자료</span>
					<input type="hidden" :name="reportTypeNm" :value="reportDetail.reportType" />
				</section>

				<h4>제목</h4>
				<section>
					<input type="text" :name="reportTitle" v-model="reportDetail.reportTitle" :disabled="isCompany" />
				</section>

				<h4>내용</h4>
				<section>
					<textarea :name="reportContents" id="" cols="30" rows="10" v-model="reportDetail.reportContents" :disabled="isCompany"></textarea>
				</section>

				<div class="business-plantitle">
					<h4 class="report">파일첨부</h4>
				</div>
				<section class="business-planfile">
					<div class="block half">
						<file-input-drag
							class="w-20"
							:target-id="reportFileForm"
							:target-name="reportFileForm"
							accept="application/haansofthwp,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
							v-if="!isCompany"
							:on-change="addFile"
							:multiple="true"
						/>
					</div>
					<div class="block" v-if="uploadReportFileList && uploadReportFileList.length > 0">
						<div
							class="block"
							:id="'uploadReportFile' + uploadReportFile.lastModified"
							v-for="(uploadReportFile, i) in uploadReportFileList"
							v-bind:key="'uploadReportFile' + i"
						>
							<div class="file-ellipsis">
								{{ uploadReportFile.name }}
							</div>
						</div>
					</div>
					<div class="block" v-if="reportDetail.reportFile && reportDetail.reportFile.length > 0">
						<div class="reportFile block" :id="'reportFile' + i" v-for="(reportFile, i) in reportDetail.reportFile" v-bind:key="'reportFile' + i">
							<div class="file-ellipsis">
								<a :href="CONST.API_SERVER + '/okta/file/' + reportFile.split('|')[0]">{{ reportFile.split('|')[1] }} </a>
							</div>
							<img
								v-if="reportFile != null && !isCompany"
								class="icon-trash trash-box"
								:src="require('../../assets/images/icon/icon-trash@2x.png')"
								@click="delFile('reportFile', i)"
							/>
							<input type="hidden" v-if="reportFile.split('|')[0] !== '0'" :name="reportFileName" :value="reportFile" />
						</div>
					</div>
				</section>

				<h4>작성자</h4>
				<section>
					<div>
						{{ reportDetail.reportWriter ? reportDetail.reportWriter : loginMemberNm }}
					</div>
				</section>
			</form>
		</div>
	</div>
</template>

<script>
import CONST from '@/constants';
import eventBus from '@/plugins/event-bus';
import FileInputDrag from '@/components/common/FileInputDrag';
import { ko } from 'vuejs-datepicker/dist/locale';
import { mapState } from 'vuex';

export default {
	title: '사업계획서',
	name: 'PopupVisit',
	props: ['modalParam'],
	components: { FileInputDrag },
	data: function() {
		return {
			ko: ko,
			CONST,
			loginMember: null,
			loginMemberNm: '',
			matchData: null,
			uploadReportFileList: [],
			dataLodingFlag: false,
			programCode: '',
			reportTypeNm: '',
			reportTitle: '',
			reportContents: '',
			reportFileForm: '',
			reportFileName: '',
			reportMetaList: [],
			reportDetail: {
				reportType: '',
				reportTitle: '',
				reportContents: '',
				reportWriter: '',
				reportFile: [],
			},
		};
	},
	watch: {},
	created() {},
	computed: {
		...mapState({
			matchSeqNo: state => state.reportMatchSeqNo,
			pNo: state => state.reportPno,
		}),
		isCompany() {
			return this.loginMember && this.loginMember.budsUserType === CONST.USER_TYPE.COMPANY;
		},
	},
	mounted() {
		this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, 'BIZ');
		let dt = this.$device.loadLocalData('LOGIN_USER');
		if (dt) {
			this.loginMember = JSON.parse(dt);
			this.loginMemberNm = this.loginMember.userNmKor;
		}
		let matchData = this.$device.loadLocalData('MATCH_DATA');
		if (matchData) this.matchData = JSON.parse(matchData);

		this.setReportInfo();

		if (this.modalParam.popupType === 'detail') this.getReportDetail();

		eventBus.$on(
			CONST.EVENTS.SAVE_MODAL,
			function(v, t) {
				if (v === 'modalMainProgramReport') {
					if (t === 'SAVE') {
						this.doSubmit('SAVE');
						return false;
					}
				}
			}.bind(this),
		);
	},
	beforeDestroy() {
		eventBus.$off(CONST.EVENTS.SAVE_MODAL);
		eventBus.$off('GET_MATCH_SEQ_NO_PNO');
	},
	methods: {
		setReportInfo: function() {
			this.programCode = 'P' + this.pNo;
			this.reportTypeNm = this.programCode + '_REPORT_TYPE';
			this.reportTitle = this.programCode + '_REPORT_TITLE';
			this.reportContents = this.programCode + '_REPORT_CONTENTS';
			this.reportFileForm = this.programCode + '_REPORT_FILE';
			this.reportFileName = this.programCode + '_REPORT_FILE';
		},
		getReportDetail: function() {
			if (this.modalParam.popupType === 'detail') {
				let formData = new FormData();
				formData.append('reportSeqNo', this.modalParam.reportSeqNo);
				formData.append('reportType', this.modalParam.reportType);
				this.$apiClient
					.getInstance()
					.post(this.$apiClient.getApiServer() + '/api/business/getReportDetail.do', formData)
					.then(res => {
						if (res.data.resultCode === 0) {
							if (res.data.data !== null) {
								this.$nextTick(() => {
									this.createLoadMetaData(res.data);
								});
							} else {
								// this.resetReportForm();
							}
						} else {
							window.alert(res.data.resultMsg);
						}
					})
					.catch(e => console.error(e));
			}
		},
		createLoadMetaData: function(dt) {
			if (dt.resultCode === 0) {
				this.reportMetaList = dt.data;
				this.reportMetaList.forEach(item => {
					if (item.contentType.indexOf('REPORT_TYPE') > -1) {
						this.reportDetail.reportType = item.contentBody;
					} else if (item.contentType.indexOf('REPORT_TITLE') > -1) {
						this.reportDetail.reportTitle = item.contentBody;
					} else if (item.contentType.indexOf('REPORT_CONTENTS') > -1) {
						this.reportDetail.reportContents = item.contentBody;
					} else if (item.contentType.indexOf('REPORT_WRITER') > -1) {
						this.reportDetail.reportWriter = item.contentBody;
					} else if (item.contentType.indexOf('REPORT_FILE') > -1) {
						this.reportDetail.reportFile.push(item.contentBody);
					}
				});
				this.dataLodingFlag = true;
			} else {
				window.alert(dt.resultMsg);
			}
		},
		addFile: function(e) {
			let fileInputList = e.target ? e.target.files : e.files;

			try {
				this.uploadReportFileList = [];
				for (var i = 0; i < fileInputList.length; i++) {
					let file = fileInputList[i];
					if (file) {
						this.uploadReportFileList.push(file);
					}
				}
			} catch (e) {
				console.error(e);
			}
		},
		delFile: function(file, i) {
			if (file === 'uploadReportFile') {
				let fileInput = document.getElementById(this.reportFileForm);
				let fileInputList = fileInput.files;

				const dataTranster = new DataTransfer();

				Array.from(fileInputList)
					.filter(file => file.lastModified != i)
					.forEach(file => {
						dataTranster.items.add(file);
					});

				fileInput.files = dataTranster.files;
			}
			let fileDiv = document.getElementById(file + i);
			fileDiv.remove();
		},
		checkFile: function() {
			let maxFileCnt = 5;
			let fileCnt = 0;

			fileCnt += document.querySelectorAll('.reportFile').length;
			fileCnt += this.uploadReportFileList.length ? this.uploadReportFileList.length : 0;

			if (maxFileCnt < fileCnt) {
				this.uploadReportFileList = [];
				document.getElementById(this.reportFileForm).value = '';
				return false;
			}

			return true;
		},
		doSubmit: function(saveType) {
			let form = document.getElementById('reportSendForm');
			let formData = new FormData(form);

			if (!formData.get(this.reportTypeNm) || formData.get(this.reportTypeNm) === null) {
				alert('문서종류를 선택해 주세요.');
				return false;
			}

			if (!formData.get(this.reportTitle)) {
				alert('제목을 입력해 주세요.');
				return false;
			}

			if (!formData.get(this.reportContents)) {
				alert('내용을 입력해 주세요.');
				return false;
			}

			if (!this.programCode) {
				alert('보고서를 다시 선택해 주세요.');
				return false;
			}

			if (!this.checkFile()) {
				alert('파일은 5개까지 업로드 가능합니다.');
				return false;
			}

			formData.append('saveType', saveType);
			formData.append('matchSeqNo', this.matchSeqNo);
			formData.append('programCode', this.programCode);
			formData.append('reportType', 'PROGRAM');
			formData.append('reportDocType', formData.get(this.reportTypeNm));
			if (this.loginMember.userNmKor) {
				formData.set(this.programCode + '_REPORT_WRITER', this.loginMember.userNmKor);
			} else {
				formData.append(this.programCode + '_REPORT_WRITER', this.reportDetail.reportWriter);
			}

			this.$apiClient
				.getInstance()
				.post(this.$apiClient.getApiServer() + '/api/business/reportSubmit2.do', formData, {
					headers: {
						'Content-Type': 'multipart/form-data',
					},
				})
				.then(res => {
					if (res.data.resultCode === 0) {
						alert('저장되었습니다.');
						eventBus.$emit(CONST.EVENTS.CLOSE_MODAL_REFRESH);
					} else {
						window.alert(res.data.resultMsg);
					}
				})
				.catch(e => console.error(e));
		},
	},
};
</script>

<style scoped></style>
